/* Browser fingerprint beacon — silent, post-login only, server-side storage only.
   Collected under the Privacy Policy ("device and browser information for security
   and fraud prevention"). Never auto-bans; feeds the admin Ban Intelligence panel. */
import api from "@/lib/api";

async function sha256(text) {
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(text));
  return [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, "0")).join("");
}

function canvasHashSource() {
  try {
    const c = document.createElement("canvas");
    c.width = 240; c.height = 60;
    const ctx = c.getContext("2d");
    ctx.textBaseline = "top";
    ctx.font = "14px 'Arial'";
    ctx.fillStyle = "#f60"; ctx.fillRect(10, 10, 90, 22);
    ctx.fillStyle = "#069"; ctx.fillText("bornwood·fp·∆≈ç√", 4, 16);
    ctx.strokeStyle = "rgba(120,40,200,0.6)"; ctx.arc(70, 30, 14, 0, 6.283);
    ctx.stroke();
    return c.toDataURL();
  } catch {
    return "unavailable";
  }
}

function webglInfo() {
  try {
    const c = document.createElement("canvas");
    const gl = c.getContext("webgl") || c.getContext("experimental-webgl");
    if (!gl) return { renderer: "", hashSrc: "no-webgl" };
    const ext = gl.getExtension("WEBGL_debug_renderer_info");
    const renderer = ext ? gl.getParameter(ext.UNMASKED_RENDERER_WEBGL) : gl.getParameter(gl.RENDERER);
    return { renderer: String(renderer || ""), hashSrc: String(gl.getParameter(gl.VERSION)) + "|" + String(renderer) };
  } catch {
    return { renderer: "", hashSrc: "blocked" };
  }
}

function estimateFonts() {
  // width-probe a handful of faces against a monospace base — count, not identity list
  const faces = ["Georgia", "Courier New", "Comic Sans MS", "Impact", "Trebuchet MS", "Verdana",
    "Times New Roman", "Helvetica", "Consolas", "Menlo", "Monaco", "Segoe UI", "Roboto", "Ubuntu"];
  const base = document.createElement("span");
  base.style.cssText = "position:absolute;left:-9999px;font-size:72px;font-family:monospace";
  base.textContent = "mmmmmmmmmmlli";
  document.body.appendChild(base);
  const baseW = base.offsetWidth;
  let count = 0;
  for (const f of faces) {
    base.style.fontFamily = `'${f}',monospace`;
    if (base.offsetWidth !== baseW) count += 1;
  }
  base.remove();
  return count;
}

export async function sendFingerprint() {
  try {
    const gl = webglInfo();
    const components = {
      canvas: await sha256(canvasHashSource()),
      webgl: await sha256(gl.hashSrc),
      gpu: gl.renderer.slice(0, 200),
      screen: `${window.screen.width}x${window.screen.height}x${window.screen.colorDepth}`,
      tz: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
      fonts: estimateFonts(),
      browser: (navigator.userAgent || "").slice(0, 120),
    };
    await api.post("/security/fingerprint", components);
  } catch {
    /* silent by design — fingerprinting never blocks or notifies the session */
  }
}
